import React from "react";
import { useEffect, useState } from "react";
import { Skeleton } from "@material-ui/lab";
import { Bar } from "react-chartjs-2";
import { useTheme } from '@material-ui/core/styles';
import { store } from "../../../../helpers/store";
import { makeStyles, Typography, Grid } from "@material-ui/core";
import { useMediaQuery } from "react-responsive";
import { useTranslation } from "react-i18next";
import moment from "moment";

const useStyle = makeStyles((theme) => ({
    noConsumption: {
        height: "15rem",
        color: theme.palette.ePrimary?.base,
    },
    skeletonStyle: {
        height: "15rem",
        marginTop: "10px"
    },
    container: {
        width: "100%",
        marginRight: "auto",
        marginLeft: "auto",
    }
}));
export default function UsageChart({ data, labels, loading, labelReady }) {
    const theme = useTheme();
    const classes = useStyle();
    var apiData = data;
    const [chartData, setChartData] = useState();
    const [options, setOptions] = useState({});
    const isTabletOrMobile = useMediaQuery({ minWidth: 768 });
    const {t:Labels, ready: labelReadyy} = useTranslation("label-HIGHEST_USAGE");
    let height;
    height = isTabletOrMobile ? "118vh" : "160vh";
    let legend = {
        display: false,
        position: "top",
        align: "center",
        textDirection: "rtl",
        onClick: (e) => null,
        labels: {
            usePointStyle: true,
            boxWidth: 5,
            color: theme.palette.ePrimary?.base
        },
        title: {
            display: false,
            text: apiData?.usageUnit ? apiData?.usageUnit : labelReady ? labels("E_USAGE_SUMMARY_UNIT") : '',
        },
        rtl: true,
    };
    let tooltip = {
        enabled: true,
        usePointStyle: true,
        position: "average",
        mode: "nearest",
        intersect: false,
        backgroundColor: theme.palette.eWhite?.base,
        bodyColor: theme.palette.eDark?.base,
        bodyFontColor: theme.palette.eDark?.base,
        borderColor: theme.palette.eLight?.base,
        padding: 10,
        borderWidth: 1,
        cornerRadius: 2,
        boxWidth: 6,
        boxHeight: 6,
        callbacks: {
            title: () => null,
            label: function (context) {
                var label = "";
                if(context.dataset.noDataDaily[context.dataIndex] === "true"){
                    label=Labels("E_NO_DATA")
                  }else{
                    let unit = apiData?.usageUnit ? apiData?.usageUnit : labelReady ? labels("E_USAGE_SUMMARY_UNIT") : "";
                       label = " " + context.parsed.y + " " + unit;
                  }
                  return [context.label, label ]
            }
        },
        displayColors: true,
    };
    let scales = {
        x: {
            stacked: false,
            ticks: {
                font: {
                    size: isTabletOrMobile ? 12 : 10,
                },
                color: theme.palette.eDark?.base,
            },
            grid: {
                display: false,
            }
        },
        y: {
            stacked: false,
            grid: {
                display: true,
                drawBorder: false
            },
            ticks: {
                font: {
                    size: isTabletOrMobile ? 12 : 10,
                },
                beginAtZero: true,
                color: theme.palette.eDark?.base,
                callback: function (value, index, values) {
                    let unit = apiData?.usageUnit ? apiData?.usageUnit : labels("E_USAGE_SUMMARY_UNIT");
                    return (value.toString() + " " + unit);
                }
            },
        },

    };
    useEffect(() => {
        let usageQuantity = [];
        let usageLabels = [];
        let noDataDaily=[];
        if (apiData) {
            store.getState().snackbar = true
            try {
                apiData.usageQuantity.forEach((item) => {
                    usageQuantity.push(item.quantity);
                    usageLabels.push(moment(item.usageDate!=""?item.usageDate:item.intervalDateTime).format("Do MMM'YY"));
                    noDataDaily.push(item.noData);
                });
            } catch (err) {
                usageQuantity = [];
            }
            let barDataSet = {
                datasets: [
                    {
                        data: usageQuantity,noDataDaily,
                        label: apiData?.usageUnit ? apiData?.usageUnit : labelReady ? labels("E_USAGE_SUMMARY_UNIT") : "",
                        backgroundColor: theme.palette.ePrimary?.base,
                        borderRadius: {
                            topLeft: 100,
                            topRight: 100
                        },
                        barPercentage: 0.2,
                    }
                ],
                labels: usageLabels
            };
            setChartData({ ...chartData, ...usageLabels, ...barDataSet })
            store.getState().snackbar = false
        }
        setOptions({
            scales: scales,
            plugins: {
                legend: legend,
                tooltip: tooltip,
            },
            layout: {
                padding: 5
            }
        });
    }, [apiData]);
    return (
        <div className={classes.container}>
            {
                loading ? (
                    <Skeleton variant="rectangular" animation="wave" className={classes.skeletonStyle} />
                ) : !chartData || chartData?.datasets[0]?.data?.length === 0 || !chartData?.datasets[0]?.data?.some(item => item != "0")? (
                    labelReady ?
                    <Grid container justify="center" alignItems="center" className={classes.noConsumption}>
                        <Typography variant="h5" align="center" >{labels("E_USAGE_SUMMARY_NO_CONSUMPTION")}</Typography>
                    </Grid>
                    : <Skeleton />
                ) : (
                    <Bar height={height} data={chartData} options={options} />
                )
            }
        </div>
    );
}